import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import ChekinProSettings from 'ChekinProSettings';
import {SDK_MODE} from 'utils/embedded';
import {PATHS} from 'Routes';
import {useSummary} from 'context/summary';
import {useGuestGroup, usePath} from 'hooks';
import {IncompleteRegisteredGuestsStep} from './IncompleteRegisteredGuestsStep';
import {CompletedGuestsStep} from './CompletedGuestsStep';
import {PrintKeyCardButton} from './PrintKeyCardButton';
import {
  NextStepRegisterContainer,
  NextStepTitle,
  StyledButton,
  ShareRegistrationLinkButton,
} from './styled';

type Props = {
  closeModal: () => void;
};
function ModalGuestRegisteredNextStepContent({closeModal}: Props) {
  const {areAllGuestsRegistered, guestGroup} = useGuestGroup();
  const {arePaymentsAvailable, areAllPaymentsCompleted} = useSummary();
  const {t} = useTranslation();
  const current = guestGroup?.added_number_of_guests;
  const total = guestGroup?.known_number_of_guests;
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const showIncompletePaymentsMessage =
    arePaymentsAvailable &&
    !areAllPaymentsCompleted &&
    ChekinProSettings.mode !== SDK_MODE.guestRegistrationOnly &&
    ChekinProSettings.mode !== SDK_MODE.onlyGuestForm;

  const getNextStepTitleKey = React.useMemo(() => {
    if (areAllGuestsRegistered) {
      if (showIncompletePaymentsMessage) {
        return 'continue_to_booking_payments';
      }
      return 'guest_registration_complete';
    }
    return 'do_you_want_to_keep_registering_guests';
  }, [areAllGuestsRegistered, showIncompletePaymentsMessage]);

  return (
    <NextStepRegisterContainer className="chekin-next-step-modal__content">
      <NextStepTitle className="chekin-next-step-modal__title">
        {t(getNextStepTitleKey)}
      </NextStepTitle>
      {!areAllGuestsRegistered ? (
        <>
          <IncompleteRegisteredGuestsStep current={current ?? 0} total={total ?? 0} />
          <ShareRegistrationLinkButton />
        </>
      ) : (
        <CompletedGuestsStep
          showIncompletePaymentsMessage={showIncompletePaymentsMessage}
        />
      )}

      <StyledButton
        link
        label={t('go_back_to_home')}
        onClick={() => navigate(getFullPath(PATHS.home))}
      />

      <PrintKeyCardButton onPrintCard={closeModal} />
    </NextStepRegisterContainer>
  );
}

export {ModalGuestRegisteredNextStepContent};
